import React, { Component } from "react";
import "./EndScreen.scss";
import Welcome from "../Welcome/Welcome";
import { GA_Push } from "../Services/GoogleAnalytics";

export default class EndScreen extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className={`section section-message ${this.props.className}`}>
                <div className="m-padding">
                    <div className="m-container">
                        <Welcome />
                        <div className="thankyou">
                            <div className="text">
                                תודה על השתתפותך
                                <span className="prize"><br />הזוכים יקבלו תשובה במייל</span>
                                <span><br />עקבו אחרינו בעמוד האינסטגרם</span>
                            </div>
                            <a onClick={(event) => {
                                event.preventDefault();
                                GA_Push("clicked_to_instagram");
                                window.open(event.target.href, "_blank");
                            }} href="https://www.instagram.com/frogifrogi" title="" target="_blank">
                                <div className="instagram"></div>
                            </a>
                        </div>
                        <div className="onetime">
                            <div className="text">
                                מותר להשתתף פעם אחת בלבד
                        </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/EndScreen/EndScreen.jsx